import React from 'react';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material/Select';

import { InputLabel } from 'InputLabel';

import { StyledMenuItem, StyledSelect } from './Pagination.styled';

type RowPerPageProps = {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onRowChange: (value: string) => void;
  rowPerPage: number;
  perPageOptions: Array<number>;
};

export function RowPerPage({ setPage, rowPerPage, perPageOptions, onRowChange }: RowPerPageProps) {
  const handlePerPageSelection = (event: SelectChangeEvent<unknown>) => {
    onRowChange(String(event.target.value));
    /*
      When a user changes the "row per page" via the Select, we automatically kick them back to the very first page.
      This was a decision made by designer Chinmay Joshi.
    */
    setPage(1);
  };

  return (
    <FormControl sx={{ verticalAlign: 'middle', marginLeft: '8px' }}>
      <InputLabel hiddenLabel={true} id="nui-rows-per-page">
        Rows Per Page
      </InputLabel>
      <StyledSelect labelId="nui-rows-per-page" onChange={handlePerPageSelection} value={rowPerPage}>
        {perPageOptions.map((page) => (
          <StyledMenuItem key={page} value={page}>
            {page + ' / page'}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}
